import React from 'react';
import { Image, Segment } from 'semantic-ui-react';
import { getCDNpath } from '../../app/common/util';

const noBank = getCDNpath('/static/images/no-bank-details-icon.png');

const NoAccounts = (props) => (
  <Segment className="no-content-segment" textAlign="center">
    <Image alt="No stored cards found!" centered src={noBank} />
    <p className={props.error ? 'error': ''}>{props.message}</p>
  </Segment>
);

export default NoAccounts;